import { render, staticRenderFns } from "./ProcessIndustrialProperty.vue?vue&type=template&id=6b264f94"
import script from "./ProcessIndustrialProperty.vue?vue&type=script&lang=js"
export * from "./ProcessIndustrialProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports